// extracted by mini-css-extract-plugin
module.exports = {"root":"_d37b01","logo":"_e55e7f"};